import { useEffect, useMemo, useRef, useState } from 'react';
import {
  flexRender,
  rowPaginationFeature,
  rowSortingFeature,
  createSortedRowModel,
  tableFeatures,
  useTable,
} from '@tanstack/react-table';
import Select from 'react-select';
import Pagination from '../GenericComponents/Pagination';
import DataTableMobile from './DataTableMobile';
import './datatable.css';
import { FaSearch, FaTimes, FaFileExcel, FaFilePdf } from 'react-icons/fa';
import { FaFilterCircleXmark } from 'react-icons/fa6';
import { MODE } from '../../interaces/mode.interface';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { es } from 'date-fns/locale';
import { SIZE_SELECT } from '../../interaces/selects.interfaces';
export function DataTable({
  columns = [],
  data = [],
  searchPlaceholder = 'Buscar ...',
  pageSize = 10,
  loading = false,
  emptyMessage = 'No se encontraron registros',
  onRowClick = () => {},

  onSearch = () => {},
  onClear = () => {},
  totalRows = 0,

  showSearch = true,
  showPagination = true,
  dataPagination = {},
  setPageData = () => {},
  pageData = { page: 1, size: 10 },

  searchValue = null,
  setSearchValue = () => {},
  othersActions = () => {},

  showCreate = false,
  titleButtonCreate = 'Nuevo',
  setOpenModal = () => {},
  setMode = () => {},
  setModel = () => {},

  //show size select
  showSizeSelect = true,
  //parametros filtros
  showFilters = false,
  dataFilters = [],
  setDataFilters = () => {},
  numberFilters = 0,

  //showExport CSV
  showExportCsv = false,
  exportCSV = () => {},

  //showExport PDF
  showExportPdf = false,
  exportPdf = () => {},
  //calendario
  showCalendar = false,
  startDate = null,
  endDate = null,
  setStartDate = () => {},
  setEndDate = () => {},
}) {
  const [currentPage, setCurrentPage] = useState(dataPagination ? dataPagination.page : 1);
  const [sizePage, setSizePage] = useState(dataPagination ? dataPagination.size : 10);
  const [globalFilter, setGlobalFilter] = useState('');
  const [filterType, setFilterType] = useState();
  const [pagination, setPagination] = useState({
    pageIndex: currentPage - 1,
    pageSize: sizePage,
  });
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: currentPage - 1,
    }));
  }, [currentPage]);

  useEffect(() => {
    setPagination({
      pageIndex: 0,
      pageSize: sizePage,
    });
  }, [sizePage]);

  const memoizedColumns = useMemo(() => columns, [columns]);
  const [sorting, setSorting] = useState([]);
  const table = useTable(
    {
      data,
      columns: memoizedColumns,

      state: {
        pagination,
        sorting,
      },

      onPaginationChange: setPagination,
      onSortingChange: setSorting,

      features: tableFeatures({
        rowPaginationFeature,
        rowSortingFeature,
        sortedRowModel: createSortedRowModel(),
      }),
    },

    (state) => ({
      pagination: state.pagination,
      sorting: state.sorting,
    })
  );
  const rows = table.getRowModel().rows;

  const totalPages = Math.ceil(totalRows / pageSize);

  const handleSearch = (value) => {
    setGlobalFilter(value);

    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }));

    onSearch(value);
  };

  const handlePageChange = (page) => {
    const pageIndex = Math.max(page - 1, 0);

    setPagination((prev) => ({
      ...prev,
      pageIndex,
    }));
  };

  const [canClearFilters, setCanClearFilters] = useState(false);
  const previousPageData = useRef({ page: pageData.page, size: pageData.size });
  useEffect(() => {
    if (dataFilters) {
      dataFilters.map((item) => {
        if (item.value_filter != '') {
          setCanClearFilters(true);
        }
      });
      if (startDate || endDate) {
        setCanClearFilters(true);
      }
    }
  }, [dataFilters, startDate, endDate]);

  useEffect(() => {
    setPageData((prev) => ({
      ...prev,
      page: currentPage,
    }));
  }, [currentPage]);

  useEffect(() => {
    const pageChanged = previousPageData.current.page !== pageData.page;
    const sizeChanged = previousPageData.current.size !== pageData.size;
    previousPageData.current = { page: pageData.page, size: pageData.size };

    if (pageChanged || sizeChanged) {
      onSearch();
    }
  }, [pageData.page, pageData.size, onSearch]);
  return (
    <div className="datatable-container">
      {(showSizeSelect || showFilters || showCalendar) && (
        <div className="div-filters">
          {showSizeSelect && (
            <div className="size-filters">
              <Select
                options={SIZE_SELECT}
                getOptionLabel={(option) => option.value}
                getOptionValue={(option) => option.key}
                value={SIZE_SELECT.find((option) => option.key === pageData.size) || ''}
                onChange={(option) => setPageData({ page: 1, size: option ? option.key : 10 })}
                placeholder="Elige una opción"
                isSearchable={false}
                classNamePrefix="select"
              />
            </div>
          )}

          {showCalendar && (
            <div className="date-filter">
              <DatePicker
                selected={startDate}
                onChange={(dates) => {
                  const [start, end] = dates;
                  setStartDate(start);
                  setEndDate(end);
                }}
                startDate={startDate}
                endDate={endDate}
                selectsRange
                dateFormat="dd/MM/yyyy"
                locale={es}
                className="date-picker-input"
                placeholderText="Rango de fechas"
              />
            </div>
          )}

          {showFilters &&
            dataFilters &&
            dataFilters.map((t, i) =>
              t.show !== false ? (
                <div key={t.filter} className={`${t.width} div-select`}>
                  <Select
                    options={t.data}
                    getOptionLabel={(option) => option.value}
                    getOptionValue={(option) => option.key}
                    value={t.data.find((option) => option.key === t.value_filter) || null}
                    onChange={(option) =>
                      setDataFilters(
                        dataFilters.map((item, index) =>
                          index === i
                            ? {
                                ...item,
                                value_filter: option ? option.key : '',
                              }
                            : item
                        )
                      )
                    }
                    placeholder="Elige una opción"
                    isSearchable={false}
                    classNamePrefix="select"
                  />
                </div>
              ) : null
            )}

          {showExportCsv && (
            <button
              type="button"
              onClick={() => exportCSV()}
              disabled={data.length === 0}
              title="Exportar a Excel / CSV"
              className="button-export-csv"
            >
              <FaFileExcel className="" />
              <span>Exportar</span>
            </button>
          )}
          {showExportPdf && (
            <button
              type="button"
              onClick={() => exportPdf()}
              disabled={data.length === 0}
              title="Exportar a PDF"
              className="button-export-pdf
    "
            >
              <FaFilePdf className="" />
              <span>Exportar</span>
            </button>
          )}
        </div>
      )}

      {showSearch && (
        <div className="datatable-search-container">
          <div
            className={`datatable-search-wrapper ${
              showCreate ? 'has-create-button' : 'without-create-button'
            }`}
          >
            {/* INPUT */}
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder={searchPlaceholder}
              className="datatable-search-input"
              onKeyDown={(e)=>{
                if(e.key==="Enter"){
                  onSearch()
                }
              }}
            />

            {/* LIMPIAR */}
            <button type="button" className="datatable-clear-button" onClick={() => onClear()}>
              <FaTimes className="datatable-clear-icon" />
            </button>

            {/* BUSCAR */}
            <button
              type="button"
              className="datatable-search-button"
              onClick={() => onSearch()}
              aria-label="Buscar"
            >
              <FaSearch className="datatable-search-icon" />
            </button>

            {/* NUEVO */}
            {showCreate && (
              <button
                type="button"
                onClick={() => {
                  setOpenModal(true);
                  setModel(null);
                  setMode(MODE.CREATE);
                }}
                className="datatable-btn-create"
              >
                <span className="text-lg leading-none">+</span>
                {titleButtonCreate}
              </button>
            )}
          </div>
        </div>
      )}

      <div className="datatable-desktop-wrapper">
        <table className="datatable-table">
          <thead className="datatable-thead">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="datatable-th"
                    style={{
                      width: header.column.columnDef.size
                        ? `${header.column.columnDef.size}px`
                        : undefined,
                      minWidth: header.column.columnDef.size
                        ? `${header.column.columnDef.size}px`
                        : undefined,
                    }}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length || 1} className="datatable-message-cell">
                  Cargando...
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={columns.length || 1} className="datatable-message-cell">
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.id} className="datatable-row" onClick={() => onRowClick(row.original)}>
                  {row.getAllCells().map((cell, index) => (
                    <td
                      key={cell.id}
                      className={`datatable-td ${index === 0 ? 'title-font-bold' : ''}`}
                      style={{
                        width: cell.column.columnDef.size
                          ? `${cell.column.columnDef.size}px`
                          : undefined,
                        minWidth: cell.column.columnDef.size
                          ? `${cell.column.columnDef.size}px`
                          : undefined,
                      }}
                    >
                      {cell.column.columnDef.cell
                        ? flexRender(cell.column.columnDef.cell, cell.getContext())
                        : String(cell.getValue() ?? '')}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <DataTableMobile
        table={table}
        loading={loading}
        emptyMessage={emptyMessage}
        onRowClick={onRowClick}
      />

      {showPagination && dataPagination && (
        <div className="datatable-pagination-container">
          <Pagination
            totalPage={dataPagination.totalPages}
            pageData={pageData}
            setPageData={setPageData}
          />
        </div>
      )}
    </div>
  );
}
